import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { Lock, Loader2, CheckCircle2 } from "lucide-react";
import { Input } from "../components/ui/input";
import { club } from "../mock";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ResetPassword() {
  const [token, setToken] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setToken(params.get("token") || "");
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 6) return setError("Password must be at least 6 characters.");
    if (password !== confirm) return setError("Passwords do not match.");
    setSubmitting(true);
    try {
      await axios.post(`${API}/auth/reset-password`, { token, new_password: password });
      setDone(true);
      setTimeout(() => navigate("/admin"), 2200);
    } catch (err) {
      const d = err?.response?.data?.detail;
      setError(typeof d === "string" ? d : "This reset link is invalid or has expired.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-5">
      <div className="w-full max-w-sm bg-card border border-white/10 rounded-xl p-8">
        <img src={club.crest} alt="crest" className="h-20 w-20 object-contain mx-auto" />
        <h1 className="display-font uppercase text-white text-2xl text-center mt-4">Reset Password</h1>

        {done ? (
          <div className="text-center mt-6" data-testid="reset-success">
            <CheckCircle2 size={44} className="text-gold mx-auto" />
            <p className="text-white/70 font-light mt-4">Your password has been updated. Redirecting to login…</p>
          </div>
        ) : !token ? (
          <p className="text-red-400 text-sm text-center mt-6" data-testid="reset-notoken">
            Missing reset token. Please use the link from your email.
          </p>
        ) : (
          <form onSubmit={submit} className="mt-6" data-testid="reset-form">
            <div className="relative">
              <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-white/40" />
              <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="New password" className="bg-background border-white/15 pl-9" data-testid="reset-password" />
            </div>
            <div className="relative mt-3">
              <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-white/40" />
              <Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="Confirm new password" className="bg-background border-white/15 pl-9" data-testid="reset-confirm" />
            </div>
            {error && <p className="text-red-400 text-sm mt-2" data-testid="reset-error">{error}</p>}
            <button type="submit" disabled={submitting} className="w-full mt-5 bg-gold text-black cond-font uppercase tracking-widest font-semibold py-3 rounded-sm hover:bg-gold-light transition-colors disabled:opacity-60 inline-flex items-center justify-center gap-2" data-testid="reset-submit">
              {submitting && <Loader2 size={16} className="animate-spin" />} Update Password
            </button>
          </form>
        )}

        <Link to="/admin" className="block text-center text-white/50 hover:text-gold text-sm mt-5 transition-colors">Back to login</Link>
      </div>
    </div>
  );
}
